import React, { useEffect, useState } from "react";
import { FileText, Mail, Maximize2, X, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { getInvoicePages } from "@/lib/apiClient";

export const DocPeek = ({ inv }) => {
  const [pages, setPages] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setPages(null);
    if (inv.page_count > 0 || inv.source === "image") getInvoicePages(inv.id).then((r) => setPages(r.pages || [])).catch(() => setPages([]));
    else setPages([]);
  }, [inv.id, inv.page_count, inv.source]);
  const hasPages = pages && pages.length > 0;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="approve-doc-peek" className="group relative flex w-full items-center gap-3 overflow-hidden rounded-xl border border-border bg-muted/40 p-2 text-left hover:border-primary/50">
        <span className="flex h-16 w-12 shrink-0 items-center justify-center overflow-hidden rounded-md bg-white shadow-sm">
          {pages === null ? <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" /> : hasPages ? <img src={pages[0]} alt="Page 1" className="h-full w-full object-cover object-top" /> : inv.source === "pdf" ? <FileText className="h-5 w-5 text-muted-foreground" /> : <Mail className="h-5 w-5 text-muted-foreground" />}
        </span>
        <span className="min-w-0 flex-1">
          <span className="block truncate text-sm font-medium">{inv.filename || "Email source"}</span>
          <span className="block text-xs text-muted-foreground">{hasPages ? `${pages.length} page${pages.length === 1 ? "" : "s"} · tap to read` : "Tap to read the source text"}</span>
        </span>
        <Maximize2 className="h-4 w-4 shrink-0 text-muted-foreground group-hover:text-foreground" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="h-[100dvh] max-h-[100dvh] w-screen max-w-none rounded-none border-0 p-0 sm:h-[90vh] sm:max-h-[90vh] sm:w-[min(900px,95vw)] sm:rounded-xl sm:border [&>button]:hidden" data-testid="approve-doc-dialog">
          <div className="flex h-full flex-col">
            <div className="flex items-center justify-between gap-3 border-b border-border px-4 py-3">
              <DialogTitle className="truncate text-sm font-medium">{inv.supplier} · {inv.invoice_number || inv.filename || "document"}</DialogTitle>
              <button type="button" onClick={() => setOpen(false)} aria-label="Close" data-testid="approve-doc-close" className="flex h-9 w-9 items-center justify-center rounded-lg hover:bg-muted"><X className="h-5 w-5" /></button>
            </div>
            {hasPages ? (
              <div className="d20-scroll flex-1 overflow-auto bg-neutral-900 p-3 space-y-3">{pages.map((src, i) => <img key={`p${i + 1}`} src={src} alt={`Page ${i + 1}`} className="w-full rounded bg-white shadow" />)}</div>
            ) : (
              <pre className="d20-scroll flex-1 overflow-auto whitespace-pre-wrap p-4 font-mono text-xs text-muted-foreground">{inv.raw_text || "No source text captured."}</pre>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
